var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrevo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "primary",
    className: "css-zbzjbd e11k6mr30",
    style: {
      minWidth: 40,
      minHeight: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#0B996E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brevo_color_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.693 11.918v-4.87h3.058c1.032 0 1.715.58 1.715 1.457 0 .998-.889 1.756-2.707 2.335-1.239.378-1.796.698-2.003 1.077l-.063.001Zm0 4.889v-2.035c0-.898.785-1.776 1.88-2.116.972-.319 1.777-.638 2.459-.977.909.52 1.466 1.416 1.466 2.355 0 1.596-1.57 2.773-3.698 2.773H9.693Zm-1.859 1.716h4.132c3.14 0 5.495-1.896 5.495-4.41 0-1.377-.723-2.614-2.004-3.412.66-.639.97-1.377.97-2.275 0-1.856-1.383-3.093-3.47-3.093H7.835v13.19Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "brevo_color_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.834 5.333h10v13.333h-10z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrevo);
export default __webpack_public_path__ + "static/media/Brevo.1d9ed633c46188637cd2946f361b27d8.svg";
export { ForwardRef as ReactComponent };